(function () {

    'use strict';

    angular.module('Services').service('LinkShipmentsTableService', LinkShipmentsTableService);

    LinkShipmentsTableService.$inject = [
        'toastr',
        'TableLiteFactory',
        '$location',
        'AccountingService',
        '$filter',
        'ConfirmationModalFactory',
        'Shipments'
    ];

    function LinkShipmentsTableService(
        toastr,
        TableLiteFactory,
        $location,
        AccountingService,
        $filter,
        ConfirmationModalFactory,
        Shipments
    ) {
        return function (shipmentId) {
            console.log(shipmentId)
            const reconcileConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.reconcileShipment.MESSAGE',
                code: 'messages.warning.reconcileShipment.CODE'
            });



            const bookingStatuses = {
                inprogress: 'Processing',
                processed: 'Completed',
                pending: 'Awaiting Booking'
            };

            const headerData = [{
                label: 'SELECT',
                class: 'text-center',
                filter: {
                    type: 'checkbox'
                }
            }, {
                label: 'Created Date',
                viewName: 'createdDate',
                filterName: 'createdDate',
                headerFn: function () {
                    tableActions.sort(this.filterName);
                }
            }, {
                label: 'CONSIGNMENT NO.',
                viewName: 'consignmentId',
                filterName: 'bbConsignmentId',
                width: '135px',
                filter: {
                    type: 'text',
                    class: 'filter-tracking-number',
                    placeholder: 'Search',
                    onSubmit: function (header) {
                        tableActions.sendRequest(tableActions.evaluateFilter(header));
                    }
                },
                headerFn: function () {
                    tableActions.sort(this.filterName);
                }
            }, {
                label: 'RECEIPT NO.',
                viewName: 'receiptNo',
                filterName: 'paymentDetails.receiptNumber',
                width: '135px',
                filter: {
                    type: 'text',
                    class: 'filter-tracking-number',
                    placeholder: 'Search',
                    onSubmit: function (header) {
                        tableActions.sendRequest(tableActions.evaluateFilter(header));
                    }
                },
                headerFn: function () {
                    tableActions.sort(this.filterName);
                }
            }, {
                label: 'PICKUP REFERENCE NO.',
                viewName: 'dhlBookingReferenceNo',
                filterName: 'carrierOrderId',
                width: '135px',
                filter: {
                    type: 'text',
                    class: 'filter-tracking-number',
                    placeholder: 'Search',
                    onSubmit: function (header) {
                        tableActions.sendRequest(tableActions.evaluateFilter(header));
                    }
                },
                headerFn: function () {
                    tableActions.sort(this.filterName);
                }
            }, {
                label: 'BBA REFERENCE NO.',
                viewName: 'bbaReferenceNo',
                filterName: 'bbaReferenceNumber',
                width: '135px',
                filter: {
                    type: 'text',
                    class: 'filter-tracking-number',
                    placeholder: 'Search',
                    onSubmit: function (header) {
                        tableActions.sendRequest(tableActions.evaluateFilter(header));
                    }
                },
                headerFn: function () {
                    tableActions.sort(this.filterName);
                }
            }, {
                label: 'Company',
                viewName: 'companyName',
                filterName: 'companyName',
                width: '135px',
                filter: {
                    type: 'text',
                    class: 'filter-tracking-number',
                    placeholder: 'Search',
                    onSubmit: function (header) {
                        tableActions.sendRequest(tableActions.evaluateFilter(header));
                    }
                },
                headerFn: function () {
                    tableActions.sort(this.filterName);
                }
            }, {
                label: ' Office/Location',
                viewName: 'locationName',
                filterName: 'locationName',
                width: '135px',

                headerFn: function () {
                    tableActions.sort(this.filterName);
                }
            }, {
                label: 'Payment Type',
                viewName: 'paymentType',
                filterName: 'paymentDetails.paymentType'
            }, {
                label: 'Account',
                viewName: 'accountEmail',
                filterName: 'userEmail',
                width: '135px',

                headerFn: function () {
                    tableActions.sort(this.filterName);
                }
            }, {
                label: 'BOOKING STATUS',
                viewName: 'bookingStatus',
                filterName: 'bookingStatus',
                width: '135px',
                filter: {
                    type: 'select2',
                    placeholder: 'Search',
                    class: 'table-input',
                    items: [{
                        value: 'pending',
                        viewName: 'Awaiting Booking'
                    }, {
                        value: 'inprogress',
                        viewName: 'Processing'
                    }, {
                        value: 'processed',
                        viewName: 'Completed'
                    }],
                    onSelect: function (header) {
                        const filter = {};
                        filter[header.filterName] = header.filter.model;
                        tableActions.sendRequest(filter);
                    },
                },
                headerFn: function () {
                    tableActions.sort(this.filterName);
                }
            }, {
                label: 'TRACKING NO.',
                viewName: 'trackingNumber',
                filterName: 'trackingNumber',
                width: '135px',
                filter: {
                    type: 'text',
                    class: 'filter-tracking-number',
                    placeholder: 'Search',
                    onSubmit: function (header) {
                        tableActions.sendRequest(tableActions.evaluateFilter(header));
                    }
                },
                headerFn: function () {
                    tableActions.sort(this.filterName);
                }
            }, {
                label: 'ORDER REF. NO.',
                viewName: 'customerReferences',
                filterName: 'customerReferences',
                width: '135px',
                filter: {
                    type: 'text',
                    class: 'filter-customer-ref',
                    placeholder: 'Search',
                    onSubmit: function (header) {
                        tableActions.sendRequest(tableActions.evaluateFilter(header));
                    }
                },
                headerFn: function () {
                    tableActions.sort(this.filterName);
                }
            }, {
                label: 'Third Party System Reference No.',
                viewName: 'wmsReference',
                filterName: 'wmsReference',
                width: '200px',
                filter: {
                    type: 'text',
                    class: 'filter-consigment-no',
                    placeholder: 'Search',
                    onSubmit: function (header) {
                        tableActions.sendRequest(tableActions.evaluateFilter(header));
                    }
                },
                headerFn: function () {
                    tableActions.sort(this.filterName);
                }
            }, {
                label: 'Linked Job',
                viewName: 'jobId',
                filterName: 'job.id',
                width: '135px',
                filter: {
                    type: 'text',
                    class: 'filter-customer-ref',
                    placeholder: 'Search',
                    onSubmit: function (header) {
                        tableActions.sendRequest(tableActions.evaluateFilter(header));
                    }
                },
                headerFn: function () {
                    tableActions.sort(this.filterName);
                }
            }, {
                label: 'CARRIER PROFILE',
                viewName: 'carrierProfileName',
                filterName: 'carrierProfileId',
                sortName: 'carrierProfile.id',
                width: '135px',
                headerFn: function () {
                    tableActions.sort(this.filterName);
                }
            },
            {
                label: 'SERVICE PROFILE',
                viewName: 'serviceProfileName',//to fix
                filterName: 'serviceProfileId',//to fix
                width: '135px',
                headerFn: function () {
                    tableActions.sort(this.filterName);
                }
            }, {
                label: 'Source Address',
                viewName: 'sourceAdd',
            }, {
                label: 'Destination Address',
                viewName: 'destinationAdd'
            }, {
                label: 'AMOUNT EX TAX',
                viewName: 'amount'
            }]

            const headData = []
            const headerAction = []

            for (let i in headerData) {
                headData.push(headerData[i])
            }

            const tableData = {
                optionAddOns: {
                    buttons: headerAction
                },
                config: {
                    noPagination: false,
                    notTopOptions: true,
                    noHeaders: false,
                    noItemsView: false,
                    noFooter: false
                },
                headers: headData,
                data: []
            };

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: Shipments.getList,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                }, postRequestErrorCallback: err => {
                    console.log(err);
                }, defaultFilters: {
                    size: 5,
                    page: 0,
                    manifested: true,
                    bookingStatus: 'PROCESSED',
                    sort: 'id,desc'
                }

            });

            init();
            function init() {

            }

            function buildTableData(data) {
                /*** START - Building of Data ***/
                if (!data)
                    return ShipmentsTableData;
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    if (shipmentId !== item.id) {
                        item.createdDate = $filter('bbaDate')(item.createdDate);
                        item.consignmentId = item.consignmentId || 'N/A';
                        item.wmsReference = item.wmsReference || 'N/A';
                        item.companyName = angular.getObjVal(item, 'company.name') || 'N/A';
                        item.locationName = angular.getObjVal(item, 'office.name') || 'N/A';
                        item.accountEmail = angular.getObjVal(item, 'user.email') || 'N/A';
                        item.carrierProfileName = angular.getObjVal(item, 'serviceProfile.carrierProfile.name') || 'N/A';
                        item.serviceProfileName = angular.getObjVal(item, 'serviceProfile.name') || 'N/A';
                        item.trackingNumber = item.trackingNumber ? item.trackingNumber : 'N/A';
                        item.jobId = angular.getObjVal(item, 'job.jobId') || 'N/A';
                        item.bbaReferenceNo = angular.getObjVal(item, 'bbaReferenceNumber') || 'N/A';

                        // item.paymentType = angular.getObjVal(item, 'paymentDetails.sweepCreditCard') ? 'Credit Card' : 'On Account';
                        if (angular.getObjVal(item, 'paymentType') === 'adhoc' || angular.getObjVal(item, 'paymentType') === 'sweep') {
                            item.paymentType = 'Credit Card - ' + angular.getObjVal(item, 'paymentType').charAt(0).toUpperCase() + angular.getObjVal(item, 'paymentType').slice(1);
                        } else {
                            item.paymentType = 'On Account';
                        }

                        item.dhlBookingReferenceNo = angular.getObjVal(item, 'carrierOrderId') || 'N/A';
                        if (item.serviceDetails) {
                            item.carrierName = {
                                type: 'logotype',
                                imgSrc: item.serviceDetails.logo
                            };
                            item.serviceName = item.serviceDetails.serviceName;
                        }
                        item.amount = Shipments.getShipmentCostFormatted(item).amountFormatted;
                        item.bookingStatus = bookingStatuses[item.bookingStatus]; // Define Bo oking Status
                        item.customerReferences =
                            item.customerReferences && item.customerReferences.length ?
                                item.customerReferences.join(', ') :
                                'N/A'; // Join Multiple Customer Refs in One
                        if (item.sourceAddress) {
                            item.sourceAdd = {
                                type: 'multiLine',
                                list: [
                                    item.sourceAddress.addressLine1 || undefined,
                                    item.sourceAddress.addressLine2 || undefined,
                                ]
                            };
                            const loc = item.sourceAddress.location;
                            if (loc) {
                                item.sourceAdd.list = item.sourceAdd.list.concat([
                                    loc.name + (loc.state ? ', ' + loc.state.code : '') + ' ' + loc.code,
                                    angular.getObjVal(loc, 'country.name')
                                ]);
                            }
                        } else {
                            item.sourceAdd = 'N/A';
                        }
                        if (item.destinationAddress) {
                            item.destinationAdd = {
                                type: 'multiLine',
                                list: [
                                    item.destinationAddress.addressLine1 || undefined,
                                    item.destinationAddress.addressLine2 || undefined,
                                ]
                            };
                            const loc = item.destinationAddress.location;
                            if (loc) {
                                item.destinationAdd.list = item.destinationAdd.list.concat([
                                    loc.name + (loc.state ? ', ' + loc.state.code : '') + ' ' + loc.code,
                                    angular.getObjVal(loc, 'country.name')
                                ]);
                            }
                        } else {
                            item.destinationAdd = 'N/A';
                        }
                        item.receiptNo = angular.getObjVal(item, 'paymentDetails.receiptNumber') || 'N/A';
                        tableData.data.push(item);
                    }

                });
                /*** END - Building of Data ***/
            }

            function updateTableData() {
                tableActions.sendRequest({});
            }

            this.updateTableData = updateTableData;
            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/LinkShipmentsTableService.js